import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TimeService } from '@bayclubs/utils';
import { debounceTime } from 'rxjs/operators';
import { camps } from '../../../models/models.generated';
import { StatisticsApiService } from '../../../services/api/statistics-api.service';
import { DashboardFilterService } from '../dashboard-filter/dashboard-filter.service';


@Component({
    selector: 'app-statistics-tiles',
    templateUrl: './statistics-tiles.component.html',
    styleUrls: ['./statistics-tiles.component.scss'],
    standalone: false
})
export class StatisticsTilesComponent implements OnInit {

    @Input()
    public filterForm: UntypedFormGroup;

    public model: camps.SystemStatistics = null;

    constructor(private statisticsService: StatisticsApiService
        , private dashboardFilterService: DashboardFilterService
        , private time: TimeService) { }

    ngOnInit() {
        this.loadStatistics();

        this.filterForm.valueChanges
            .pipe(debounceTime(100))
            .subscribe(() => {
                this.model = null;
                this.loadStatistics();
            });
    }

    private loadStatistics(): void {

        const filter = this.dashboardFilterService.getFilterResult(this.filterForm.controls['dateRange'].value);
        const campType = this.filterForm.controls['campType'].value;

        this.statisticsService.getSystem(<camps.StatisticsRequest>{
            dateFrom: this.time.toBcDate(filter.dateFrom),
            dateTo: this.time.toBcDate(filter.dateTo),
            timezone: this.time.defaultTimezone(),
            campTypes: campType ? [campType] : []
        }).subscribe(result => {
            if (result.isSuccess) {
                this.model = result.value
            }
        });
    }
}
